export default __webpack_public_path__ + "media/color/ebst-69ec90a5.svg";